import Vue from 'vue'

import _ from 'lodash'
Vue.filter('currentyCodeToSymbol', function (value, code) {
  var symbols = {GBP: '£', USD: '$', EUR: '€'}
  var sym = symbols[code]
  if (!value) { value = 0 }
  return sym + `${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
})
Vue.filter('priceLabelToSymbol', function (value, code) {
  var symbols = {TEFLORG: '£', TEFLUS: '$', IRELAND: '€', undefined: '£'}
  var sym = symbols[code]
  if (!value) { value = 0 }
  return sym + `${value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
})
Vue.filter('niceStatus', function (code) {
  var symbols = {0: 'Pending', 1: 'Deposit Paid', 2: 'Fully Paid', 4: 'Cancelled'}
  var sym = symbols[code]
  return sym
})
Vue.filter('niceRegion', function (code) {
  var symbols = {ALL: 'All regions', TEFLORG: 'The UK', TEFLUS: 'The US', IRELAND: 'Ireland'}
  var sym = symbols[code]
  return sym
})
Vue.filter('regionToFlag', function (code) {
  var symbols = {ALL: 'All', TEFLORG: 'static/img/flags/UK.png', TEFLUS: 'static/img/flags/US.png', IRELAND: 'static/img/flags/EU.png'}
  var sym = symbols[code]
  return sym
})
Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('codeToCurrency', function (value) {
  if (value === 'GBP') return '£'
  if (value === 'USD') return '$'
  if (value === 'EUR') return 'Ꞓ'
})
Vue.filter('venue', function (value) {
  return value.split('-')[1]
})
Vue.filter('town', function (value) {
  return value.split('-')[2].slice(0, -4)
})
Vue.filter('expiryDate', function (value) {
  var g = _.find(value, function (o) { return o.key === 'expiryDate' })
  return g.value
})

Vue.filter('learnerAgreement', function (value) {
  var g = _.find(value, function (o) { return o.key === 'signedLearnerAgreement' })
  if (g.value === 1) { return true } else { return false }
})



// WEBPACK FOOTER //
// ./src/filters.js